
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsfab8aff52ae243edbdf170a99e6f5a07en from './en.yaml'
            i18n.addResourceBundle('en', 'fab8aff52ae243edbdf170a99e6f5a07', flattenObject(nsfab8aff52ae243edbdf170a99e6f5a07en), true, true);
        
        export default 'fab8aff52ae243edbdf170a99e6f5a07';
    